import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as M from "materialize-css/dist/js/materialize";

@Injectable({
    providedIn: 'root'
})
export class ResourcesService {

    /* route: string = 'http://localhost:8081'; */
    route: string = 'http://45.55.243.116:8081';
    // routePlanta: string = 'http://localhost:3001';
    routePlanta: string = 'http://45.55.243.116:8192';

    versionBE = '';
    versionModulo = 'Poultry';
    internet: any = {
        wifi: 'wifi',
        wifi_icon: 'wifi',
        status: 'Conexión establecida'
    };
    galponesState: boolean = false;
    lotesState: boolean = false;
    corralesState: boolean = false;
    semanasState: boolean = false;
    nacimientosState: boolean = false;
    stdGranjaState: boolean = false;
    stdPlantaState: boolean = false;
    falta_subir: any = [];
    Loading: boolean

    constructor(
        private router: Router,
        private http: HttpClient
    ) { }

    async updateLocalStorageFromOnline() {
        const data: any = this.http.get(this.route + '/galpones').toPromise()
        try {
            for (let i = 0; i < data.length; i++) {
                data[i]['fecha_creacion'] = '2020-01-12T23:00:00.000Z'
            }
            localStorage.setItem('galpones', JSON.stringify(data));
            this.galponesState = true;
        } catch (error) {
            this.galponesState = null;
        }
        const dataLotes: any = await this.http.get(this.route + '/lotes').toPromise()
        try {

            localStorage.setItem('lotes', JSON.stringify(dataLotes));
            this.lotesState = true;
        } catch (error) {
            this.lotesState = null;
        }
        const dataCorrales = await this.http.get(this.route + '/corrales').toPromise()
        try {
            await localStorage.setItem('corrales', JSON.stringify(dataCorrales));
            this.corralesState = true;
        } catch (error) {
            this.corralesState = null;
        }
        const dataSemanas: any = await this.http.get(this.route + '/semanas').toPromise()
        try {
            localStorage.setItem('semanas', JSON.stringify(dataSemanas.map(d => ({ ...d, online: 1 }))));
            this.semanasState = true;
        } catch (error) {
            this.semanasState = null;
        }
        const dataNacimiento: any = await this.http.get(this.routePlanta + '/nacimiento/poultry').toPromise()
        try {

            localStorage.setItem('nacimientos', JSON.stringify(dataNacimiento.map(d => ({ ...d, online: 1 }))));
            this.nacimientosState = true;
        } catch (error) {
            this.nacimientosState = false;
        }
        const stdGranjaData = await this.http.get(this.route + '/semanas/std/Granja').toPromise()
        try {
            await localStorage.setItem('stdGranja', JSON.stringify(stdGranjaData));
            this.stdGranjaState = true;
        } catch (error) {
            this.stdGranjaState = null;
        }
        const dataPlanta: any = await this.http.get(this.route + '/semanas/std/Planta').toPromise()
        try {
            localStorage.setItem('stdPlanta', dataPlanta);
            this.stdPlantaState = true;
        } catch (error) {
            this.stdPlantaState = null;
        }
    }

    updateOnlineFromLocalStorage() {
        this.http.get(this.route + '/galpones').subscribe(
            (data: any) => {
                this.falta_subir = [];
                // SI HAY ACCESO AL BACKEND

                // Todo esto va en ONLINE
                var falta_json = localStorage.getItem('falta_subir')
                if (falta_json == '' || falta_json == undefined) {
                    console.log('No hay data que falte subir')
                } else {
                    this.router.navigate(['/galpones/']);
                    this.Loading = true;
                    var falta_subir = JSON.parse(falta_json)

                    // falta_subir.forEach(e => {
                    //     e.state = null;
                    //     this.falta_subir.push(e);
                    // });

                    // console.log('this.falta_subir :>> ', this.falta_subir);

                    this.http.post(this.route + '/semanas/localstorage/', falta_subir).subscribe(
                        async (data: any) => {
                            // if(data.success == true){
                            for (let i = 0; i < falta_subir.length; i++) {
                                await this.http.post(this.route + '/semanas/', falta_subir[i]).subscribe(
                                    (data: any) => {
                                        // VALIDAR QUE ESTA EN LA BASE DE DATOS DESDE EL BACKEND
                                        if (data.success == true) {
                                            let nfj = JSON.parse(localStorage.getItem('falta_subir'))
                                            nfj.forEach((r, j) => {
                                                if (r.semana == falta_subir[i].semana) {
                                                    nfj.splice(j, 1)
                                                }
                                            });
                                            localStorage.setItem('falta_subir', JSON.stringify(nfj))
                                            // falta_subir[i].state = true;
                                            M.toast({ html: data.message + falta_subir[i]['semana'] })
                                        } else {
                                            // falta_subir[i].state = false;
                                            console.log('data.error :>> ', data.error);
                                            M.toast({ html: "No subió la Semana " + falta_subir[i]['semana'] + " (" + data.error.code + ")", classes: 'red' })
                                        }
                                        // SI NO ESTA EN LA DB O SALE ERROR GUARDE LOS QUE FALLEN
                                        // AGREGAR BARRA DE PROGRESO
                                    }, error => console.log('NO SE PUDO SUBIR LA DATA PENDIENTE DE PESOS', error)
                                )
                            }
                            // }
                            this.Loading = false;
                        }, error => console.log('NO SE GUARDO EN LA TABLA BACKUP', error)
                    )
                }

                var falta_json_corral = localStorage.getItem('falta_subir_corral')
                if (falta_json_corral == '' || falta_json_corral == undefined) {
                    console.log('No hay data de corrales que falte subir')
                } else {

                    var falta_subir_corral = JSON.parse(falta_json_corral)
                    console.log('falta_subir_corral', falta_subir_corral)
                    for (let i = 0; i < falta_subir_corral.length; i++) {
                        this.http.post(this.route + '/corrales/', falta_subir_corral[i]).subscribe(
                            (data: any) => {
                                console.log('SE SUBIÓ CORRECTAMENTE LA DATA QUE FALTABA DE CORRAL', data)
                                M.toast({ html: 'Se sincronizó correctamente el corral ' + falta_subir_corral[i]['corral'] })
                            },
                            error => console.log('NO SE PUDO SUBIR LA DATA QUE FALTABA DE CORRAL', error)
                        )
                        // Despues de insertar todos borramos la data
                        if ((i + 1) == falta_subir_corral.length) {
                            localStorage.removeItem('falta_subir_corral');
                            this.router.navigate(['/galpones/']);
                        }
                    }

                }

            }, error => console.log('No hay acceso al backed para subir lo que falta')
        )

    }

    updateSemanasFromOnline() {
        this.http.get(this.route + '/semanas').subscribe(
            (data: any) => {
                for (let i = 0; i < data.length; i++) {
                    data[i]['online'] = 1
                }
                console.log('LOCAL STORAGE SEMANAS DONE!', data)
                localStorage.setItem('semanas', JSON.stringify(data));
            }
        );
    }
}
